if(!customElements.get('page-manager')) {
  class PageManager extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.firstLoadedPage = parseInt(this.dataset.currentPage);
      this.lastLoadedPage = parseInt(this.dataset.currentPage);
      this.totalPages = parseInt(this.dataset.totalPages);
      this.paginationMode = this.dataset.paginationMode;
      this.itemsContainer = this.querySelector(this.dataset.itemsContainerSelector);
      this.onHistoryChangeHandler = this.onHistoryChange.bind(this);
      var multiplePageManagersExist = document.querySelectorAll('page-manager').length>1;
      this.monitorHistoryChange = this.paginationMode=='pager' && !multiplePageManagersExist;
      this.updateUrlPageParameter = !multiplePageManagersExist;
      this.restoreScroll = this.paginationMode=='load_more' || this.paginationMode=='infinite_scroll';
      this.lastSearchString = location.search;
      this.loadPageRequestId = 0;
      this.lastStatePersistedAt = 0;
      if (this.restoreScroll) {
        if (history.scrollRestoration) {
          history.scrollRestoration = 'manual';
        }
        var top = history.state?.pscroll;
        if (top !== undefined && top !== null) {
          var pageStartDiv = this.querySelector('[data-page="'+ this.dataset.currentPage +'"]');
          if (pageStartDiv) {
            document.documentElement.scrollTop = document.body.scrollTop = pageStartDiv.offsetTop + top/1;
          }
        }
      }

      if (this.monitorHistoryChange) {
        window.addEventListener('popstate', this.onHistoryChangeHandler);
      }
      if(this.paginationMode == 'infinite_scroll' || this.paginationMode == 'load_more') {
        this.onScrollHandler = this.onScroll();
        this.onResizeHandler = this.onResize();
        this.pagesOffset = null;
        this.currentPersistedPage = null;
        window.addEventListener('scroll', this.onScrollHandler);
        window.addEventListener('resize', this.onResizeHandler);
      }

      const pageNumber = parseInt(this.dataset.currentPage||1);
      if (pageNumber < parseInt(this.dataset.totalPages||1) ) {
        this.preloadItems(pageNumber + 1);
      }
      if (pageNumber > 1) {
        this.preloadItems(pageNumber - 1);
      }

    }

    getPageParam() {
      return this.dataset.pageParam || 'page';
    }

    getFormattedPageUrl(pageNumberOrUrl) {
      const url =  new URL(isNaN(pageNumberOrUrl) ? pageNumberOrUrl : location.href);
      if (!isNaN(pageNumberOrUrl)) {
        url.searchParams.set(this.getPageParam(), pageNumberOrUrl);
      }
      url.searchParams.set('sections', this.sectionId);
      return url.toString();
    }

    preloadItems(pageNumber) {
      if (
        $s.connectionDataSavingRating() ||
        pageNumber < 1 ||
        pageNumber > this.totalPages
      ) {
        return;
      }
      $s.preloadPage(this.getFormattedPageUrl(pageNumber), true).catch(()=>{});
    }

    disconnectedCallback() {
      if (this.monitorHistoryChange) {
        window.removeEventListener('popstate', this.onHistoryChangeHandler);
      }
      if(this.paginationMode == 'infinite_scroll' || this.paginationMode == 'load_more') {
        window.removeEventListener('scroll', this.onScrollHandler);
        window.removeEventListener('resize', this.onResizeHandler);
      }
    }

    onHistoryChange(e) {
      if (this.lastSearchString == window.location.search)
        return;
      $s.showLoadingOverlay();
      this.loadPage(window.location.href, ()=>{
        $s.hideLoadingOverlay();
      }, false, null, null, ()=>{
        $s.hideLoadingOverlay();
      });
    }

    onScroll() {
      return $s.throttle(this.updateCurrentUrl.bind(this), 500);
    }

    onResize() {
      return $s.throttle(()=>{
          this.pagesOffset = null;
          this.updateCurrentUrl();
        }, 500);
    }

    loadItems(pageNumber, callbackAfterUpdate, callbackBeforeUpdate, callbackError) {
      const url = this.getFormattedPageUrl(pageNumber);
      return $s.preloadPage(url, true).then((data)=>{
        var html = data[this.sectionId];
        if (typeof html !== 'string') {
          throw new Error('Invalid section response');
        }
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var items = doc.querySelectorAll(this.dataset.itemSelector);
        if (callbackBeforeUpdate)
          callbackBeforeUpdate(items);

        if (items.length > 0) {
          var newPage = items[0].getAttribute('data-page')/1;
          var offsetContainer = this.itemsContainer;
          var currentItems = offsetContainer.querySelectorAll(this.dataset.itemSelector+'[data-page]');
          var offsetInsertMethod = 'beforeend';
          for (var i=0; i<currentItems.length; i++) {
            if (currentItems[i].getAttribute('data-page')/1 > newPage) {
              offsetContainer = currentItems[i];
              offsetInsertMethod = 'beforebegin';
              break;
            } else {
              offsetContainer = currentItems[i];
              offsetInsertMethod = 'afterend';
            }
          }

          items.forEach(function(item) {
            offsetContainer.insertAdjacentHTML(offsetInsertMethod, item.outerHTML);
            if (offsetInsertMethod=='afterend') {
              offsetContainer = offsetContainer.nextSibling;
            }
          });

          this.lastLoadedPage = Math.max(pageNumber, this.lastLoadedPage);
          this.firstLoadedPage = Math.min(pageNumber, this.firstLoadedPage);
          this.pagesOffset = null;
          this.updateCurrentUrl();
        }

        if (callbackAfterUpdate)
          callbackAfterUpdate(items);

        this.dispatchEvent(new CustomEvent('pageLoaded'));
        this.preloadItems(pageNumber - 1);
        this.preloadItems(pageNumber + 1);
        return items;
      }).catch((error)=>{
        if (callbackError) {
          callbackError(error);
        }
        return [];
      });
    }

    loadPage(url, callback, updateHistory=true, callbackBeforeUpdate, updateHandler, callbackError) {
      if(typeof url === 'string' && url.indexOf(window.location.origin)<0) {
        url = window.location.origin + url;
      } 
      url = new URL(url);
      const requestId = ++this.loadPageRequestId;

      return $s.preloadPage(this.getFormattedPageUrl(url), true).then((data)=>{
        if (requestId != this.loadPageRequestId) {
          return false;
        }
        var html = data[this.sectionId];
        if (typeof html !== 'string') {
          throw new Error('Invalid section response');
        }
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var newPageManager = doc.querySelector('page-manager');
        if (!newPageManager) {
          throw new Error('Page manager missing from section response');
        }

        if (callbackBeforeUpdate) callbackBeforeUpdate(doc);

        this.lastSearchString = url.search;
        if(updateHistory && this.updateUrlPageParameter) {
          this.persistState(url.toString(), url.toString(), this.monitorHistoryChange);
        }

        if (updateHandler) {
          updateHandler(this, newPageManager);
        } else {
          this.parentNode.replaceChild(newPageManager, this);
        }

        if(callback) callback();
        this.dispatchEvent(new CustomEvent('pageLoaded'));
        return true;
      }).catch((error)=>{
        if (requestId == this.loadPageRequestId && callbackError) {
          callbackError(error);
        }
        return false;
      });
    }

    persistState(state, url, usePushState) {
      //Safari throws a SecurityError once its history update budget is exceeded;
      //the URL is only a convenience, so a failure must not break pagination.
      try {
        if (usePushState) {
          history.pushState(state, '', url);
        } else {
          history.replaceState(state, '', url);
        }
        return true;
      } catch (error) {
        return false;
      }
    }

    updateCurrentUrl() {
      if (!this.updateUrlPageParameter) {
        return;
      }
      if(this.paginationMode == 'infinite_scroll' || this.paginationMode == 'load_more') {
        if (!this.pagesOffset) {
          this.pagesOffset = [];
          //calculate offsets
          var items = this.querySelectorAll(this.dataset.itemSelector+'[data-page]');
          items.forEach((item)=>{
            var page = item.getAttribute('data-page');
            if (!this.pagesOffset[page]) {
              this.pagesOffset[page] = {"number": page, "offset": item.offsetTop};
            }
          });
        }

        const offsetTop = document.documentElement.scrollTop || document.body.scrollTop;
        var pages = Object.keys(this.pagesOffset).sort(function(a,b) {return a/1>b/1 ? 1 : -1});
        var currentPage = pages.length > 0 ? pages[0] : this.dataset.currentPage || 1;
        const vHeight = (window.innerHeight || document.documentElement.clientHeight);
        const gapTop = vHeight / 2;

        for (var i=0; i<pages.length; i++) {
          var page = this.pagesOffset[pages[i]];
          if (page.offset - gapTop < offsetTop) {
            currentPage = page.number;
          } else {
            break;
          }
        }

        const pageChanged = this.currentPersistedPage != currentPage;
        if (pageChanged || this.restoreScroll) {
          //Scroll-only writes are spaced out to stay within Safari's history budget.
          const now = Date.now();
          if (!pageChanged && now - this.lastStatePersistedAt < 1000) {
            return;
          }
          this.currentPersistedPage = currentPage;
          var url = new URL(location.href);
          url.searchParams.set(this.getPageParam(), currentPage);
          const state = {};
          if (this.restoreScroll) {
            var pageStartDiv = this.querySelector('[data-page="'+ this.currentPersistedPage +'"]');
            if (pageStartDiv) {
              var pageStartTop = pageStartDiv.offsetTop;
              state.pscroll = (offsetTop - pageStartTop);
            }
          }
          this.persistState(state, url.toString());
          this.lastStatePersistedAt = now;
        }
        
      }
    }
  }
  customElements.define('page-manager', PageManager);
}

if(!customElements.get('pagination-pager')) {
  class PaginationPager extends HTMLElement {
    constructor() {
      super();
      this.pageManager = this.closest('page-manager');
      this.ajax = true;

      if(this.ajax) {
        this.querySelectorAll('a[href]:not(.disabled)').forEach((element)=>{
          element.addEventListener('click', (e)=>{
            e.preventDefault();
            $s.showLoadingOverlay();
            this.pageManager.loadPage(element.href, ()=>{
              var newTop = document.querySelector(this.pageManager.dataset.itemsContainerSelector).offsetTop - document.getElementById('header').offsetHeight - 80
              if (newTop<60) {
                newTop = 0;
              }
              $s.hideLoadingOverlay();
              window.scrollTo(0, newTop);
            }, true, null, null, ()=>{
              $s.hideLoadingOverlay();
            });
          });
        });
      }
    }
  }
  customElements.define('pagination-pager', PaginationPager);
}

if(!customElements.get('pagination-load-more')) {
  class PaginationLoadMore extends HTMLElement {
    constructor() {
      super();
      this.pageManager = this.closest('page-manager');
      this.loading = this.querySelector('.pagination-loading');
      this.isLoading = false;

      this.button = this.querySelector('.btn-load-more');
      this.button.addEventListener('click', (event)=>{
        event.preventDefault();
        this.loadMore();
      });
      this.ui();
    }

    getNextPageUrl() {
      const url = new URL(location.href);
      url.searchParams.set(this.pageManager.getPageParam(), this.pageManager.lastLoadedPage + 1);
      url.searchParams.delete('sections');
      return url.toString();
    }

    ui() {
      if(this.pageManager.lastLoadedPage < this.pageManager.totalPages) {
        this.button.href = this.getNextPageUrl();
        this.button.removeAttribute('aria-disabled');
        this.button.removeAttribute('tabindex');
        this.button.classList.remove('hide');
      } else {
        this.button.style.display = 'none';
      }
    }

    loadMore() {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      if (this.loading) {
        this.loading.classList.remove('hide');
      }
      this.button.setAttribute('aria-disabled', 'true');
      this.button.setAttribute('tabindex', '-1');

      this.pageManager.loadItems(this.pageManager.lastLoadedPage + 1, (items)=>{
        this.isLoading = false;
        if (this.loading) {
          this.loading.classList.add('hide');
        }
        this.ui();
      }, null, ()=>{
        this.isLoading = false;
        if (this.loading) {
          this.loading.classList.add('hide');
        }
        this.ui();
      });
    }
  }
  customElements.define('pagination-load-more', PaginationLoadMore);
}

if(!customElements.get('pagination-infinite-scroll')) {
  class PaginationInfiniteScroll extends HTMLElement {
    constructor() {
      super();
      this.type = this.dataset.type;
      this.pageManager = this.closest('page-manager');
      this.scrollDownHandler = this.onScrollDown.bind(this);
      this.scrollUpHandler = this.onScrollUp.bind(this);
      this.loading = this.querySelector('.pagination-loading');
      this.isLoading = false;
      this.observer = null;

      if(this.type=='down') {
        this.observe(this.scrollDownHandler);
        window.addEventListener('scroll', this.scrollDownHandler);
        this.scrollDownHandler();
      }
      if(this.type=='up') {
        this.observe(this.scrollUpHandler);
        window.addEventListener('scroll', this.scrollUpHandler);
        this.scrollUpHandler();
      }
    }

    observe(handler) {
      //Safari coalesces scroll events during momentum scrolling, so the scroll
      //listener alone can miss the trigger. Root margin matches isNearViewport.
      if (!('IntersectionObserver' in window)) {
        return;
      }
      const rootMargin = $s.media.isSmall ? '150% 0px' : '50% 0px';
      this.observer = new IntersectionObserver((entries)=>{
        if (entries.some((entry)=>entry.isIntersecting)) {
          handler();
        }
      }, {rootMargin: rootMargin});
      this.observer.observe(this);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.scrollDownHandler);
      window.removeEventListener('scroll', this.scrollUpHandler);
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }

    setLoading(isLoading) {
      this.isLoading = isLoading;
      if (this.loading) {
        this.loading.classList.toggle('hide', !isLoading);
      }
    }

    isNearViewport() {
      const {top} = this.getBoundingClientRect();
      const viewportHeight = window.visualViewport?.height || window.innerHeight || document.documentElement.clientHeight;
      const triggerDistance = viewportHeight * ($s.media.isSmall ? 1.5 : 0.5);
      return top <= viewportHeight + triggerDistance;
    }

    onScrollDown() {
      if (!this.isLoading && this.isNearViewport()) {
        window.removeEventListener('scroll', this.scrollDownHandler);
        if (this.pageManager.lastLoadedPage < this.pageManager.totalPages) {
          this.setLoading(true);
          this.pageManager.loadItems(this.pageManager.lastLoadedPage + 1, (items)=>{
            this.setLoading(false);
            if (this.pageManager.lastLoadedPage >= this.pageManager.totalPages) {
              this.remove();
            } else if (this.isConnected) {
              window.addEventListener('scroll', this.scrollDownHandler);
              this.scrollDownHandler();
            }
          }, null, ()=>{
            this.setLoading(false);
            if (this.isConnected) {
              window.addEventListener('scroll', this.scrollDownHandler);
            }
          });
        } else {
          this.remove();
        }
      }
    }

    onScrollUp() {
      var currentScrollTop;
      var prevPageHeight;

      if (!this.isLoading && $s.isInViewport(this)) {
        window.removeEventListener('scroll', this.scrollUpHandler);
        if (this.pageManager.firstLoadedPage > 1) {
          this.setLoading(true);
          this.pageManager.loadItems(this.pageManager.firstLoadedPage- 1, (items)=>{
            //after ui update;
            this.setLoading(false);
            if (this.pageManager.firstLoadedPage==1) {
              this.remove();
            }
            var diff = this.pageManager.offsetHeight - prevPageHeight;
            document.documentElement.scrollTop = document.body.scrollTop = currentScrollTop + diff;
            if (this.isConnected) {
              window.addEventListener('scroll', this.scrollUpHandler);
              this.scrollUpHandler();
            }
          }, (items)=>{
            //before ui update;
            prevPageHeight = this.pageManager.offsetHeight;
            currentScrollTop = document.documentElement.scrollTop || document.body.scrollTop
          }, ()=>{
            this.setLoading(false);
            if (this.isConnected) {
              window.addEventListener('scroll', this.scrollUpHandler);
            }
          });
        } else {
          this.remove();
        }
      }
    }
  }
  customElements.define('pagination-infinite-scroll', PaginationInfiniteScroll);

  class PageResultsEnd extends HTMLElement {
    constructor() {
      super();
      this.pageManager = this.closest('page-manager');
      this.hideFeaturedItemsOutOfBoundsHandler = this.hideFeaturedItemsOutOfBounds.bind(this);
      window.addEventListener('mediaChange', this.hideFeaturedItemsOutOfBoundsHandler);
      this.hideFeaturedItemsOutOfBounds();
      this.pageManager.addEventListener('pageLoaded', this.hideFeaturedItemsOutOfBoundsHandler);
    }
    disconnectedCallback() {
      window.removeEventListener('mediaChange', this.hideFeaturedItemsOutOfBoundsHandler);
      this.pageManager.removeEventListener('pageLoaded', this.hideFeaturedItemsOutOfBoundsHandler);
    }
    hideFeaturedItemsOutOfBounds() {
      var lastResult = this.previousElementSibling;
      var lastResultBounds = lastResult ? lastResult.getBoundingClientRect() : {bottom: -100, height:0, left: -100, right: -100, top: -100, width:0, x: -100, y: -100};
      var featuredItems = this.closest('page-manager').querySelectorAll('.collage-item');
      featuredItems.forEach(item=> {
        var itemBounds = item.getBoundingClientRect();
        var visible = true && lastResultBounds.height > 0;
        if (itemBounds.bottom == lastResultBounds.bottom) {
          var lastResultStyle = window.getComputedStyle(lastResult);
          var itemStyle = window.getComputedStyle(item);
          if (!isNaN(itemStyle.gridRowStart) && !isNaN(itemStyle.gridRowEnd)) {
            //for display Grid
            if (itemBounds.left -1 > lastResultBounds.right) {
              visible = false; //when they end at the same row but there is a space between them
            } else {
              var itemRowCount = itemStyle.gridRowEnd - itemStyle.gridRowStart;
              if (itemRowCount>1) {
                var estimatedRows = Math.round(itemBounds.height / lastResultBounds.height);
                if (itemRowCount!=estimatedRows) {
                  visible = false;  //when they end at the same row but the featured item should cover more rows (Grid Mode)
                }
              }
            }
          } else {
            //for display Flex
            if (lastResultStyle.order && itemStyle.order) {
              if (lastResultStyle.order/1 + 1 < itemStyle.order/1) {
                visible = false;
              }
            }
          }
        } else if (itemBounds.bottom > lastResultBounds.bottom || itemBounds.top >=lastResultBounds.bottom) {
          visible = false;  //when the featured item is in the next row
        }
        
        item.style.display = visible ? '' : 'none';
      });
    }
  }
  customElements.define('page-results-end', PageResultsEnd);
}